export default __webpack_public_path__ + "static/media/3135.8a9fd50e.jpg";